<template>
  <el-dialog :title="categoryDialogTitle" :visible.sync="dialogVisible" width="400px" @close="handleClose">
    <el-form :model="formData" :rules="rules" ref="categoryForm" label-width="100px">
      <el-form-item prop="nameZh">
        <template slot="label">
          <div class="custom-label">
            <div>{{ operationTitle }}</div>
            <div class="field-label-hint">（xx个字内）</div>
          </div>
        </template>
        <div class="name-inputs">
          <div class="name-input-item">
            <span class="name-label">简体:</span>
            <el-input v-model="localFormData.nameZh" placeholder="请输入简体分类名称" class="name-input"></el-input>
          </div>
          <div class="name-input-item">
            <span class="name-label">繁体:</span>
            <el-input v-model="localFormData.nameTw" placeholder="请输入繁体分类名称" class="name-input"></el-input>
          </div>
          <div class="name-input-item">
            <span class="name-label">英文:</span>
            <el-input v-model="localFormData.nameEn" placeholder="请输入英文分类名称" class="name-input"></el-input>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { createLanguageData } from "@/utils/college";

export default {
  name: "AddCategoryDialog",
  props: {
    categoryVisible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({
        nameZh: "",
        nameTw: "",
        nameEn: "",
        parentId: null
      })
    },
    operationTitle: {
      type: String,
      default: ""
    },
    categoryDialogTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      rules: {
        nameZh: [{ required: true, message: "请输入简体分类名称", trigger: "blur" }]
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.categoryVisible;
      },
      set(val) {
        this.$emit("update:categoryVisible", val);
      }
    },
    localFormData: {
      get() {
        return this.formData;
      },
      set(val) {
        this.$emit("update:formData", val);
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$refs.categoryForm.validate((valid) => {
        if (!valid) return;
        const name = createLanguageData(
          this.localFormData.nameZh,
          this.localFormData.nameTw,
          this.localFormData.nameEn
        );
        this.$emit("handleCategoryDialogConfirm", {
          ...this.localFormData,
          name
        });
      });
    },
    handleClose() {
      this.$emit("handleCategoryDialogClose");
    }
  }
};
</script>

<style scoped>
.name-inputs {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.name-input-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.name-label {
  width: 50px;
  white-space: nowrap;
  font-size: 14px;
}

.name-input {
  flex: 1;
}

.custom-label {
  display: flex;
  flex-direction: column;
  text-align: left;
  line-height: 1.5;
  padding-top: 5px;
}

:deep(.el-form-item__label) {
  text-align: left;
  padding: 0;
}

:deep(.el-dialog__body) {
  overflow: hidden;
}

:deep(.el-form-item.is-required .el-form-item__label) {
  display: flex;
  align-items: flex-start;
}

:deep(.el-form-item.is-required .el-form-item__label::before) {
  margin-top: 5px;
  line-height: 1.5;
}

.field-label-hint {
  font-size: 10px;
  color: #f56c6c;
  margin-left: 4px;
}
</style>
